// extracted by mini-css-extract-plugin
module.exports = {"skipToContent":"Header_skipToContent__P_Yug","leftToRight":"Header_leftToRight__Y4k33"};